import "../css/Footer.css"
const Footer = () => {
  return (
    <footer className="footer bg-dark text-light">
      <div className="container py-5">
        <div className="row g-4">

          {/* Coordonnées */}
          <div className="col-12 col-md-4">
            <h5 className="fw-semibold mb-3">Contact</h5>
            <p className="mb-1">Association LSR47</p>
            <p className="mb-1">📍 MVA 54 rue Coquard 47200 Villeneuve-sur-lot</p>
            <p className="mb-1">📞 06 16 43 97 29</p>
            <a href="mailto:mfc1.bournazel@orange.fr" className="mb-0">✉️ mfc1.bournazel@orange.fr</a>
          </div>

          {/* Plan du site */}
          <div className="col-12 col-md-4">
            <h5 className="fw-semibold mb-3">Plan du site</h5>
            <ul className="list-unstyled">
              <li>
                <a href="/" className="footer-link">Accueil</a>
              </li>
              <li>
                <a href="/qsn" className="footer-link">Qui sommes-nous?</a>
              </li>
              <li>
                <a href="/evenements/passes" className="footer-link">Évènements</a>
              </li>
              <li>
                <a href="/partenaires" className="footer-link">Partenaires</a>
              </li>
              <li>
                <a href="/contact" className="footer-link">Contact</a>
              </li>
            </ul>
          </div>

          {/* Informations légales */}
          <div className="col-12 col-md-4">
            <h5 className="fw-semibold mb-3">Informations</h5>
            <ul className="list-unstyled">
              <li>
                <a href="/mentions-legales" className="footer-link">
                  Mentions légales
                </a>
              </li>
              <li>
                <a href="/politique-confidentialite" className="footer-link">
                  Politique de confidentialité
                </a>
              </li>
            </ul>
          </div>

        </div>

        <hr className="border-secondary my-4" />

        <div className="text-center small text-muted">
          © {new Date().getFullYear()} LSR47 — Tous droits réservés
        </div>
      </div>
    </footer>
  );
};

export default Footer;
